import axios from '../../axios/index.js'

export default{
    categories(){
        return axios.get('get_categories')        
    },
    types(){
        return axios.get('ehs_catalog/get_types')        
    },
    frequencies(){
        return axios.get('ehs_catalog/get_frequencies') 
    },
    getFacilities(client_id = null){
        return axios.get('general/getFacilities',{ params: { client_id } })
    },
    getGlobalNotifications(){
        return axios.get('notificacions/ehs')
    },
    checkSetting(key){
        return axios.get('setting/'+key)
    }
}